import { useState } from "react";
import { Box, Modal } from "@mui/material";

import { StripePayModal, useStripePayModal } from "../../../../../shared/StripePayModal";

import { GINO_QUERY_KEYS } from "../../../api/queryKeys";
import { GinoAddOns } from "../../../api/services/ginoAddOns";
import { GinoCreditsData } from "../../../api/services/ginoCredits";

import { AddOnsStep } from "./AddOnsStep";
import { CreditsInfoStep } from "./CreditsInfoStep";
import { PurchasedSuccessfullyStep } from "./PurchasedSuccessfullyStep";

export const GinoCreditModal = ({
  open,
  onClose,
  ginoCredits,
  initialStep,
}: {
  open: boolean;
  onClose: () => void;
  ginoCredits: GinoCreditsData;
  initialStep?: 0 | 1 | 2;
}) => {
  const [step, setStep] = useState<0 | 1 | 2>(initialStep ?? 0);
  const [selectedPack, setSelectedPack] = useState<GinoAddOns | null>(null);
  const handleNextStep = () => {
    if (step === 2) return;
    setStep((prev) => (prev + 1) as 0 | 1 | 2);
  };

  const handleClose = () => {
    setStep(initialStep || 0);
    setSelectedPack(null);
    onClose();
  };

  const { handleOpenStripePayModal, openStripePayModal, handleCloseStripePayModal, clientSecret, publishableKey } =
    useStripePayModal();

  const content = {
    0: <CreditsInfoStep onClose={onClose} ginoCredits={ginoCredits} onNextStep={handleNextStep} />,
    1: (
      <>
        <AddOnsStep
          onClose={handleClose}
          selectedPack={selectedPack}
          setSelectedPack={setSelectedPack}
          handleOpenStripePayModal={handleOpenStripePayModal}
        />
        <StripePayModal
          open={openStripePayModal}
          closeModal={handleCloseStripePayModal}
          clientSecret={clientSecret}
          publishableKey={publishableKey}
          queryKey={[...GINO_QUERY_KEYS.GINO_CREDITS]}
          onSuccess={handleNextStep}
        />
      </>
    ),
    2: <PurchasedSuccessfullyStep onClose={onClose} selectedPack={selectedPack} />,
  };

  return (
    <Modal open={open} onClose={handleClose} sx={styles.modal}>
      <Box>{content[step]}</Box>
    </Modal>
  );
};

const styles = {
  modal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
};
